import { initialize } from 'redux-form';

import { loading, success, handleErrorException } from 'State/actions';
import { INGREDIENT_GROUPS_FORM_NAME } from 'Common/FormEnum';
import { ControlInfoIngredientGroupsFormEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getIngredientGroups = () => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.GET_INGREDIENT_GROUPS_LOADING, true));
    const response = await MPWWebApi.getGeneric(
      `Ingredient/GetIngredientGroups`
    );

    dispatch(
      initialize(INGREDIENT_GROUPS_FORM_NAME, {
        [ControlInfoIngredientGroupsFormEnum.IngredientGroups]:
          response.data.Data,
      })
    );
    dispatch(success(types.GET_INGREDIENT_GROUPS_SUCCESS, response.data.Data));
  } catch (error) {
    dispatch(
      handleErrorException(error, types.GET_INGREDIENT_GROUPS_ERROR, {
        Title: 'Error',
        Message: `Could not retrieve ingredient groups.`,
      })
    );
  } finally {
    dispatch(loading(types.GET_INGREDIENT_GROUPS_LOADING, false));
  }
};

export const writeIngredientGroup = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.WRITE_INGREDIENT_GROUPS_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'Ingredient/WriteIngredientGroups',
      data
    );

    dispatch(
      success(types.WRITE_INGREDIENT_GROUPS_SUCCESS, response.data.Data)
    );

    dispatch(
      initialize(INGREDIENT_GROUPS_FORM_NAME, {
        [ControlInfoIngredientGroupsFormEnum.IngredientGroups]:
          response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.WRITE_INGREDIENT_GROUPS_ERROR, {
        Title: 'Error',
        Message: 'Could not save ingredient groups.',
      })
    );
    return false;
  } finally {
    dispatch(loading(types.WRITE_INGREDIENT_GROUPS_LOADING, false));
  }
};

export const deleteIngredientGroups = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.DELETE_INGREDIENT_GROUP_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'Ingredient/WriteIngredientGroups',
      data
    );

    dispatch(
      success(types.DELETE_INGREDIENT_GROUP_SUCCESS, response.data.Data)
    );

    dispatch(
      initialize(INGREDIENT_GROUPS_FORM_NAME, {
        [ControlInfoIngredientGroupsFormEnum.IngredientGroups]:
          response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.DELETE_INGREDIENT_GROUP_ERROR, {
        Title: 'Error',
        Message: 'Could not delete Ingredient Group.',
      })
    );
    return false;
  } finally {
    dispatch(loading(types.DELETE_INGREDIENT_GROUP_LOADING, false));
  }
};

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});

export const getIngredientSources = () => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.GET_INGREDIENT_SOURCES_LOADING, true));
    const response = await MPWWebApi.getGeneric(
      'Ingredient/GetIngredientSources'
    );
    const sources = response.data.Data;
    dispatch(success(types.GET_INGREDIENT_SOURCES_SUCCESS, sources));
  } catch (error) {
    dispatch(
      handleErrorException(error, types.GET_INGREDIENT_SOURCES_ERROR, {
        Title: 'Error',
        Message: `Could not retrieve ingredient sources.`,
      })
    );
  } finally {
    dispatch(loading(types.GET_INGREDIENT_SOURCES_LOADING, false));
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/ingredientGroup/actions.js